"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestSlotGroupDtoMinTierEnum = void 0;
exports.instanceOfDigestSlotGroupDto = instanceOfDigestSlotGroupDto;
exports.DigestSlotGroupDtoFromJSON = DigestSlotGroupDtoFromJSON;
exports.DigestSlotGroupDtoFromJSONTyped = DigestSlotGroupDtoFromJSONTyped;
exports.DigestSlotGroupDtoToJSON = DigestSlotGroupDtoToJSON;
exports.DigestSlotGroupDtoToJSONTyped = DigestSlotGroupDtoToJSONTyped;
var DigestSlotDto_1 = require("./DigestSlotDto");
/**
 * @export
 */
exports.DigestSlotGroupDtoMinTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the DigestSlotGroupDto interface.
 */
function instanceOfDigestSlotGroupDto(value) {
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('minTier' in value) || value['minTier'] === undefined)
        return false;
    if (!('unlocked' in value) || value['unlocked'] === undefined)
        return false;
    if (!('slots' in value) || value['slots'] === undefined)
        return false;
    return true;
}
function DigestSlotGroupDtoFromJSON(json) {
    return DigestSlotGroupDtoFromJSONTyped(json, false);
}
function DigestSlotGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'],
        'minTier': json['minTier'],
        'unlocked': json['unlocked'],
        'slots': (json['slots'].map(DigestSlotDto_1.DigestSlotDtoFromJSON)),
    };
}
function DigestSlotGroupDtoToJSON(json) {
    return DigestSlotGroupDtoToJSONTyped(json, false);
}
function DigestSlotGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
        'minTier': value['minTier'],
        'unlocked': value['unlocked'],
        'slots': (value['slots'].map(DigestSlotDto_1.DigestSlotDtoToJSON)),
    };
}
